import React, {useState} from "react";
import {Modal} from 'react-bootstrap';


export default function DeleteModal({btnClass, btnText, confirmDelete}) {
    let user = sessionStorage.getItem('user')
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <div className="pointer" onClick={handleShow}>
                {btnText}
            </div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Дали сте сигурни дека сакате да ја избришете ставката?</Modal.Title>
                </Modal.Header>
                {/*<Modal.Body>*/}
                {/*    <p></p>*/}
                {/*</Modal.Body>*/}
                <Modal.Footer>
                     <div className="d-flex justify-content-center w-100">
                        <div
                            className={btnClass}
                            onClick={(e)=> {
                                confirmDelete()
                                handleClose()
                            }
                            }>Избриши</div>
                    </div>
                    </Modal.Footer>
            </Modal>
        </>
    );
}